import React from "react";
import { API, graphqlOperation } from "aws-amplify";
const rowFields = [
  { label: "SPX", key: "sp" },
  { label: "GOLD", key: "gold" },
  { label: "BTC", key: "bitcoin" },
  { label: "BRENT OIL", key: "oil" },
  { label: "CRB INDEX", key: "commodity" },
];
const defaultData = rowFields.map((obj) => {
  return {
    asset: obj.label,
    fifteenChange: 0,
    thirtyChange: 0,
    sixtyChange: 0,
    ninetyChange: 0,
    oneTwentyChange: 0,
    oneEightyChange: 0,
    emptyCell: "",
    high: 0,
    low: 0,
    plus: 0,
    minus: 0,
  };
});
export default function USDCorrelations(props) {
  const [data, setData] = React.useState(defaultData);

  React.useEffect(() => {
    refresh();
  }, []);

  React.useEffect(() => {
    if (props.reload) {
      setData(defaultData);
      refresh();
    }
  }, [props.reload]);

  const refresh = async () => {
    const data = (
      await API.graphql(
        graphqlOperation(`{
      python_scripts_cache_by_pk(id: "correlations") {
        data
      }
    }
    `),
      )
    ).data.python_scripts_cache_by_pk.data;
    setData(
      rowFields.map((obj) => {
        return {
          asset: obj.label,
          fifteenChange: data[obj.key + "_15"],
          thirtyChange: data[obj.key + "_30"],
          sixtyChange: data[obj.key + "_60"],
          ninetyChange: data[obj.key + "_90"],
          oneTwentyChange: data[obj.key + "_120"],
          oneEightyChange: data[obj.key + "_180"],
          emptyCell: "",
          high: data[obj.key + "_max"],
          low: data[obj.key + "_min"],
          plus: data[obj.key + "_maxchg"],
          minus: data[obj.key + "_minchg"],
        };
      }),
    );
  };
  function greaterThanZero(num) {
    return num > 0 ? "green" : "red";
  }

  const tableData = data.map((row, i) => {
    return (
      <div className="asset-info-row" key={i}>
        <div className="cell-first">{row.asset}</div>
        <div className={`cell-info ${greaterThanZero(row.fifteenChange)}`}>
          {row.fifteenChange && row.fifteenChange.toFixed(2)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.thirtyChange)}`}>
          {row.thirtyChange && row.thirtyChange.toFixed(2)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.sixtyChange)}`}>
          {row.sixtyChange && row.sixtyChange.toFixed(2)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.ninetyChange)}`}>
          {row.ninetyChange && row.ninetyChange.toFixed(2)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.oneTwentyChange)}`}>
          {row.oneTwentyChange && row.oneTwentyChange.toFixed(2)}
        </div>
        <div className={`cell-info ${greaterThanZero(row.oneEightyChange)}`}>
          {row.oneEightyChange && row.oneEightyChange.toFixed(2)}
        </div>
        <div className="cell-info transparent"></div>
        <div
          className={`cell-info`}
          style={
            row.high > 0.0
              ? { color: "#75CE41" }
              : row.high === 0.0
              ? { color: "white" }
              : row.high < 0.0
              ? { color: "#d33541" }
              : {}
          }
        >
          {row.high && row.high.toFixed(2)}
        </div>
        <div
          className={`cell-info`}
          style={
            row.low > 0.0
              ? { color: "#75CE41" }
              : row.low === 0.0
              ? { color: "white" }
              : row.low < 0.0
              ? { color: "#d33541" }
              : {}
          }
        >
          {row.low && row.low.toFixed(2)}
        </div>
        <div
          className={`cell-info`}
          style={
            row.plus > 0.0
              ? { color: "#75CE41" }
              : row.plus === 0.0
              ? { color: "white" }
              : row.plus < 0.0
              ? { color: "#d33541" }
              : {}
          }
        >
          {row.plus && row.plus?.toFixed(2)}%
        </div>
        <div
          className={`cell-info`}
          style={
            row.minus > 0.0
              ? { color: "#75CE41" }
              : row.minus === 0.0
              ? { color: "white" }
              : row.minus < 0.0
              ? { color: "#d33541" }
              : {}
          }
        >
          {row.minus && row.minus?.toFixed(2)}%
        </div>
      </div>
    );
  });

  return (
    <section className="section usd-correlations">
      <div className="section-title">USD Correlations</div>

      <div className="main-headers">
        <div></div>
        <div className="top-header">Correlation Analysis</div>
        <div></div>
        <div className="top-header">52 Week Rolling 30 Day Correlation</div>
      </div>

      <div className="sub-header-correlations">
        <div className="sub-header-index" style={{ textAlign: "left" }}>
          <div className="transparent">.</div>
          <div style={{ position: "relative", paddingLeft: 15 }}>Asset</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>15D</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>30D</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>60D</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>90D</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>120D</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>180D</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div className="transparent">.</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>High</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>Low</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>%(+)</div>
        </div>
        <div className="sub-header-index">
          <div className="transparent">.</div>
          <div>%(-)</div>
        </div>
      </div>
      <div className="usd-correlation-content">{tableData}</div>
    </section>
  );
}
